export const PlayerBpm = {
        "player1":[
            127,
            127,
            126,
            126,
            116,
            101,
            101,
            101,
            100,
            99,
            98,
            98,
            98,
            100,
            101,
            109,
            111,
            109,
            109,
            110,
            109,
            106,
            104,
            106,
            108,
            108,
            111,
            114,
            115,
            116,
            115,
            119,
            121,
            121,
            119,
            113,
            110,
            108,
            109,
            111,
            111,
            112,
            112,
            112,
            113,
            113,
            109,
            111,
            114,
            113,
            110,
            108,
            111,
            113,
            116,
            119,
            120,
            121,
            120,
            119,
            119,
            118,
            116,
            113,
            114,
            113,
            113,
            115,
            107,
            105,
            102,
            100,
            99,
            98,
            99,
            105,
            113,
            117,
            114,
            115,
            117,
            115,
            114,
            116,
            121,
            121,
            122,
            122,
            122,
            123,
            124,
            125,
            125,
            125,
            125,
            126,
            128,
            129,
            129,
            130,
            132,
            134,
            134,
            134,
            135,
            135,
            133,
            133,
            133,
            132,
            133,
            133
        ],
        "player2":[
            134,
            134,
            134,
            135,
            138,
            139,
            139,
            141,
            142,
            144,
            145,
            147,
            148,
            150,
            152,
            154,
            155,
            156,
            158,
            159,
            159,
            159,
            158,
            158,
            157,
            157,
            156,
            157,
            156,
            153,
            151,
            151,
            150,
            150,
            150,
            149,
            148,
            148,
            148,
            148,
            147,
            147,
            146,
            146,
            145,
            145,
            145,
            144,
            144,
            145,
            144,
            143,
            142,
            141,
            141,
            141,
            142,
            142,
            142,
            141,
            141,
            140,
            141,
            142,
            142,
            142,
            141,
            140,
            141,
            141,
            137,
            135,
            135,
            135,
            136,
            138,
            136,
            136,
            137,
            134,
            134,
            135,
            137,
            138,
            135,
            133,
            132,
            131,
            131,
            133,
            134,
            134,
            134,
            132,
            132,
            133,
            130,
            127,
            129,
            130,
            130,
            131,
            131,
            131,
            130,
            129,
            127,
            124,
            121,
            119,
            118,
            118
        ],
        "player3":[
            117,
            116,
            116,
            115,
            114,
            114,
            113,
            112,
            112,
            111,
            109,
            113,
            115,
            111,
            114,
            114,
            117,
            116,
            114,
            111,
            109,
            109,
            111,
            115,
            118,
            119,
            120,
            121,
            121,
            120,
            118,
            102,
            100,
            101,
            99,
            96,
            94,
            95,
            94,
            94,
            96,
            95,
            95,
            95,
            95,
            99,
            102,
            105,
            105,
            105,
            105,
            105,
            105,
            104,
            102,
            101,
            102,
            110,
            114,
            117,
            121,
            122,
            122,
            124,
            125,
            125,
            127,
            125,
            125,
            125,
            124,
            123,
            124,
            122,
            121,
            122,
            123,
            123,
            122,
            123,
            119,
            119,
            117,
            118,
            119,
            120,
            120,
            121,
            120,
            118,
            118,
            119,
            120,
            118,
            116,
            118,
            119,
            119,
            121,
            119,
            116,
            119,
            121,
            121,
            122,
            119,
            117,
            117,
            117,
            118,
            118,
            119
        ],
        "player4":[
            120,
            121,
            122,
            123,
            123,
            122,
            122,
            120,
            116,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123,
            123,
            122,
            123,
            123,
            119,
            120,
            121,
            121,
            120,
            119,
            118,
            116,
            116,
            115,
            112,
            113,
            111,
            114,
            118,
            118,
            117,
            118,
            120,
            120,
            117,
            114,
            111,
            110,
            112,
            112,
            115,
            114,
            115,
            114,
            114,
            115,
            114,
            114,
            114,
            116,
            118,
            120,
            121,
            121,
            122,
            122,
            122,
            123,
            120,
            119,
            119,
            118,
            114,
            112,
            116,
            118,
            120,
            121,
            121,
            120,
            119,
            118,
            119,
            118,
            113,
            114,
            113,
            114,
            115,
            113,
            111,
            109,
            107,
            107,
            110,
            113,
            115,
            117,
            114,
            113,
            114,
            112,
            113,
            114,
            112,
            108,
            110,
            111,
            113,
            115,
            116,
            115,
            111,
            111,
            114
        ],
        "player5":[
            116,
            115,
            115,
            114,
            111,
            107,
            108,
            109,
            111,
            112,
            114,
            115,
            116,
            116,
            113,
            114,
            115,
            117,
            118,
            116,
            115,
            117,
            118,
            119,
            120,
            120,
            120,
            118,
            118,
            119,
            120,
            121,
            121,
            121,
            122,
            122,
            122,
            122,
            122,
            121,
            119,
            119,
            120,
            117,
            116,
            118,
            119,
            120,
            121,
            121,
            120,
            122,
            122,
            122,
            122,
            121,
            121,
            121,
            118,
            114,
            114,
            114,
            116,
            117,
            118,
            118,
            119,
            119,
            118,
            114,
            115,
            115,
            115,
            115,
            115,
            114,
            116,
            117,
            117,
            119,
            118,
            117,
            117,
            117,
            115,
            113,
            113,
            112,
            111,
            112,
            114,
            115,
            116,
            118,
            118,
            118,
            115,
            115,
            115,
            115,
            115,
            117,
            117,
            118,
            118,
            117,
            117,
            118,
            120,
            121,
            119,
            119
        ],
        "player6":[
            121,
            123,
            123,
            122,
            121,
            121,
            121,
            121,
            120,
            117,
            115,
            116,
            115,
            115,
            112,
            109,
            108,
            105,
            104,
            104,
            105,
            104,
            106,
            108,
            111,
            113,
            115,
            116,
            118,
            119,
            119,
            120,
            119,
            118,
            118,
            118,
            116,
            117,
            117,
            118,
            118,
            117,
            118,
            120,
            121,
            121,
            121,
            119,
            117,
            117,
            117,
            118,
            117,
            118,
            119,
            117,
            117,
            117,
            117,
            115,
            114,
            113,
            113,
            115,
            118,
            120,
            121,
            118,
            115,
            115,
            115,
            118,
            119,
            118,
            117,
            112,
            112,
            112,
            112,
            114,
            117,
            114,
            112,
            112,
            111,
            112,
            112,
            114,
            115,
            117,
            117,
            117,
            116,
            115,
            115,
            113,
            114,
            114,
            116,
            116,
            115,
            116,
            116,
            115,
            115,
            115,
            114,
            112,
            109,
            108,
            105,
            104
        ],
        "player7":[
            104,
            107,
            108,
            109,
            108,
            106,
            106,
            105,
            106,
            105,
            104,
            102,
            99,
            98,
            97,
            97,
            99,
            98,
            96,
            99,
            100,
            101,
            103,
            106,
            106,
            104,
            101,
            99,
            98,
            94,
            92,
            90,
            90,
            93,
            94,
            94,
            94,
            94,
            90,
            88,
            87,
            86,
            86,
            87,
            86,
            85,
            85,
            84,
            84,
            86,
            88,
            88,
            88,
            89,
            88,
            86,
            85,
            85,
            85,
            85,
            92,
            94,
            93,
            93,
            98,
            100,
            100,
            98,
            95,
            96,
            96,
            95,
            92,
            92,
            90,
            90,
            91,
            92,
            93,
            92,
            90,
            92,
            93,
            94,
            94,
            94,
            95,
            93,
            87,
            85,
            82,
            81,
            81,
            81,
            83,
            84,
            87,
            88,
            89,
            91,
            91,
            91,
            92,
            93,
            93,
            93,
            93,
            93,
            93,
            93,
            93,
            93
        ],
        "player8":[
            94,
            94,
            94,
            95,
            94,
            92,
            92,
            93,
            94,
            94,
            95,
            97,
            98,
            98,
            98,
            98,
            98,
            95,
            94,
            94,
            94,
            94,
            94,
            93,
            93,
            93,
            92,
            92,
            92,
            92,
            92,
            91,
            91,
            90,
            90,
            91,
            92,
            93,
            93,
            94,
            93,
            93,
            93,
            94,
            95,
            95,
            97,
            97,
            95,
            94,
            94,
            94,
            94,
            95,
            96,
            95,
            94,
            94,
            94,
            94,
            93,
            93,
            93,
            93,
            92,
            91,
            92,
            93,
            93,
            94,
            98,
            99,
            99,
            97,
            95,
            94,
            94,
            94,
            83,
            82,
            81,
            82,
            84,
            85,
            86,
            88,
            90,
            91,
            91,
            90,
            91,
            93,
            95,
            95,
            95,
            95,
            94,
            93,
            92,
            91,
            92,
            95,
            95,
            96,
            94,
            92,
            91,
            90,
            90,
            89,
            88,
            88
        ]
    }; 